import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ElementRef,
  AfterViewInit,
} from "@angular/core";
import "rxjs/add/operator/filter";
import {
  state,
  style,
  transition,
  animate,
  trigger,
  AUTO_STYLE,
} from "@angular/animations";
import { LocalStorageService } from "ng2-webstorage";
import { MenuItems } from "../../shared/menu-items/menu-items";
import {
  NavigationEnd,
  Router,
  Event as RouterEvent,
} from '@angular/router';
import { AddUserFirebaseService } from "../../components/manageuser/adduser/adduserfirebase.service";
import { attachmentModel } from "./attachment.model";
import { NoticeboardService } from "../../components/noticeboard/noticeboard/noticeboard.service";
import { MessageService } from "primeng/components/common/messageservice";
import { AppConstants } from "../../app.constants";
import { AdminLayoutService } from "../../layouts/admin/admin-layout.service";
import { filter } from "rxjs/operator/filter";
import { AppService } from "../../app.service";
import { exit } from "process";
import { Token } from "@angular/compiler";
export interface Options {
  heading?: string;
  removeFooter?: boolean;
  mapHeader?: boolean;
}

@Component({
  selector: "app-layout",
  templateUrl: "./admin-layout.component.html",
  styleUrls: ["./admin-layout.component.css"],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger("mobileMenuTop", [
      state(
        "no-block, void",
        style({
          overflow: "hidden",
          height: "0px",
        })
      ),
      state(
        "yes-block",
        style({
          height: AUTO_STYLE,
        })
      ),
      transition("no-block <=> yes-block", [animate("400ms ease-in-out")]),
    ]),
  ],
})
export class AdminLayoutComponent implements OnInit {
  display: boolean = false;
  isQuantaEnabled = 0;
  deviceType = "desktop";
  verticalNavType = "expanded";
  verticalEffect = "shrink";
  innerHeight: string;
  isCollapsedMobile = "no-block";
  isCollapsedSideBar = "no-block";
  toggleOn = true;
  attachmentModel = new attachmentModel();
  attachment: string;
  windowWidth: number;
  public SchoolName: any;
  public UserRole: any;
  public LoggedUsername: any;
  public htmlButton: string;
  public schoolId: string;
  public userId: string;
  public schoolLogo: string;
  public imgUrl: string;
  public homemenu: string;
  public userUrl: string = "/schooluser/";
  public data: any;
  public maxSize: number = 10;
  public bigTotalItems: number = 10;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public term: any;
  public searchString: string = "";
  public spinnershow: boolean = false;
  public userData: any;
  private count: number;
  private unsubscribe: any;


  base = '';
  page = '';
  currentUrl = '';


  public menuData = [
    {
      label: "",
      main: [],
    },
  ];
  public GCLMenu = {
    id: 6,
    state: "googleClassroom",
    name: "Virtual Classroom",
    type: "sub",
    icon: "fa fa-laptop",
    children: [
      {
        //   name: "Assignments",
        //   state: "coursesList"
        // },{
        name: "Create Class",
        state: "createClass",
      },

      {
        name: "Assignment Detail",
        state: "assignment",
      },
      // {
      //   name: 'Student Record',
      //   state: 'student-detail',
      // },
      // {
      //   name: 'Classes Grade detail',
      //   state: 'class-detail',
      // },
      {
        name: "Google Reports",
        state: "google-report",
      },
    ],
  };

  // public PRO =
  // {
  //   id: 7,
  //   state: 'userProfile',
  //   name: 'User-Profile',
  //   type: 'link',
  //   icon: 'fa fa-manage-user',
  // }

  public AdminData = {
    id: 7,
    state: "dataAnalytics",
    name: "Data Analytics",
    type: "sub",
    icon: "fa fa-bar-chart",
    children: [
      // {
      //   name: "Summary",
      //   state: "summarydata",
      // },
      // {
      //   name: "Students",
      //   state: "students",
      // },
      //{
      //  name: "Teachers",
      //  state: "teachers",
      // },
      {
        name: "Digital Report Card",
        state: "digital-report-card",
      },
      /*{
        name: "Add Subject",
        state: "addSubject",
      },
      {
        name: "Add Sub Subject",
        state: "subSubject",
      },
      {
        name: "Add Semester",
        state: "addSemester",
      },
      {
        name: "Add Academicyear",
        state: "AddAcademicyear",
      },*/
      {
        name: "Settings",
        state: "selectdashboard",
      },
      /*{
        name: "Add Grade to Level",
        state: "addgradetolevel",
      },
      {
        name: "Level Add to school",
        state: "LevelAddSchool",
      },*/
    ],
  };

  public TeacherData = {
    id: 7,
    state: "dataAnalytics",
    name: "Data Analytics",
    type: "sub",
    icon: "fa fa-user",
    children: [
      // {
      //   name: "Summary",
      //   state: "summarydata",
      // },
      // {
      //   name: "Students",
      //   state: "students",
      // },
      // {
      //   name: "Teachers",
      //   state: "teachers",
      // },
      {
        name: "Digital Report Card",
        state: "digital-report-card",
      },
      // {
      //   name: "Add Subject",
      //   state: "addSubject",
      // },
      // {
      //   name: "Add Semester",
      //   state: "addSemester",
      // },
    ],
  };

  public teacherMenu = {
    id: 6,
    state: "googleClassroom",
    name: "Virtual Classroom",
    type: "sub",
    icon: "fa fa-user",
    children: [
      {
        name: "Classroom Confirmation",
        state: "approvalList",
      },
      {
        name: "Assignment Upload",
        state: "coursesList",
      },
      {
        name: "Assignment Review",
        state: "assignment",
      },
      {
        name: "Video Class",
        state: "googlemeet",
      },
      // {
      //   name: 'Student Record',
      //   state: 'student-detail',
      // },
      {
        name: "Classes Grade detail",
        state: "class-detail",
      },
      // {
      //   name: 'Import Google Classes',
      //   state: 'importclasses',
      // }
    ],
  };

  public CourseMenu = {
    id: 6,
    state: "course",
    name: "Course",
    type: "sub",
    icon: "fa fa-user",
    children: [
      {
        name: "View",
        state: "viewcourse",
      },
      {
        name: "Semester",
        state: "semester",
      },
      {
        name: "Add subject to module",
        state: "semsubject",
      },
      {
        name: "Add Submodule",
        state: "submodule",
      },
      {
        name: "Add Teacher subject",
        state: "teachersubject",
      },
    ],
  };

  public BatchMenu = {
    id: 6,
    state: "batch",
    name: "Batch",
    type: "sub",
    icon: "fa fa-user",
    children: [
      {
        name: "Batches",
        state: "batchers",
      },
    ],
  };

  public teacherdetailsmenu = {
    id: 10,
    state: "teacher",
    name: "Teacher Details",
    type: "sub",
    icon: "fa fa-user",
    children: [
      {
        name: "View",
        state: "teachers-view",
      },
      {
        name: "Registration",
        state: "add-teacher",
      },
      {
        name: "Subject Assign",
        state: "add-subject",
      },
    ],
  };

  constructor(
    public menuItems: MenuItems,
    public appService: AppService,
    private localStorage: LocalStorageService,
    private adminLayoutService: AdminLayoutService,
    private router: Router,
    private addfirebaseService: AddUserFirebaseService,
    private appConstants: AppConstants,
    private noticeboardService: NoticeboardService,
    private msgService: MessageService
  ) {
    router.events.subscribe((event: RouterEvent) => {
      if (event instanceof NavigationEnd) {
        this.getRoutes(event);
      }
    });

    this.localStorage.store("daStatus", {Value: 'Enabled'});
    this.getGclStatus();
    //this.getDAStatus();
    var isAdmin = this.localStorage.retrieve("isschooladminuser");
    this.isQuantaEnabled = this.localStorage.retrieve("isquantaenabled");
    if (isAdmin == false) {
      this.GCLMenu = this.teacherMenu;
      this.AdminData = this.TeacherData;
    }
    const scrollHeight = window.screen.height - 150;
    this.innerHeight = scrollHeight + "px";
    this.windowWidth = window.innerWidth;
    this.setMenuAttributs(this.windowWidth);
    this.SchoolName = this.localStorage.retrieve("School");
    this.UserRole = this.localStorage.retrieve("UserRole");
    this.LoggedUsername = this.localStorage.retrieve("Username");
    this.schoolLogo = this.localStorage.retrieve("Logo");
    this.imgUrl = this.appConstants.fileDownloadUrl;
    this.homemenu = this.localStorage.retrieve("homemenu");
    // this.getGclStatus();
    // this.htmlButton = '<div class="fixed-button">';
    // this.htmlButton += '<a href="https://codedthemes.com/item/mash-able-pro-admin-template/" class="btn btn-primary" aria-hidden="true">';
    // this.htmlButton += 'Upgrade To Pro</a>';
    // this.htmlButton += '</div>';
  }

  @ViewChild('fileInput') fileInput: ElementRef;


  ngOnInit() {
    this.getPrivateSB(this.bigCurrentPage);
    this.unsubscribe = this.appService.subject.subscribe((Response: any) => {
      // this.count = Response;
    });

    //this.PageRefresh = Observable.interval(10000).subscribe(Response => this.getPrivateSB(this.bigCurrentPage));
  }


  private getRoutes(route: any): void {
    this.setActiveRoute(route.url);
  }



  private setActiveRoute(url: string): void {
    console.log(url);

    // Extract the last part of the URL
    const lastSegment = url.split('/').pop(); // Get the last segment of the URL
    console.log(lastSegment);

    // Compare with exact matches
    if (lastSegment === 'dashboard') {
      this.base = 'dashboard';
      this.page = 'dashboard';
    } else if (lastSegment === 'noticeboard') {
      this.base = 'noticeboard';
      this.page = 'noticeboard';
    } else if (lastSegment === 'outbox') {
      this.base = 'outbox';
      this.page = 'outbox';
    } else if (lastSegment === 'soundingboard') {
      this.base = 'soundingboard';
      this.page = 'soundingboard';
    } else if (lastSegment === 'calendar') {
      this.base = 'calendar';
      this.page = 'calendar';
    }else if (lastSegment === 'settings') {
      this.base = 'settings';
      this.page = 'settings';
    } else if (lastSegment === 'department') {
      this.base = 'department';
      this.page = 'department';
    } else if (lastSegment === 'user') {
      this.base = 'user';
      this.page = 'user';
    } else if (lastSegment === 'Groups') {
      this.base = 'Groups';
      this.page = 'Groups';
    } else if (lastSegment === 'View') {
      this.base = 'View';
      this.page = 'View';
    } else if (lastSegment === 'PromotionsS') {
      this.base = 'PromotionsS';
      this.page = 'PromotionsS';
    } else if (lastSegment === 'ViewRegistration') {
      this.base = 'ViewRegistration';
      this.page = 'ViewRegistration';
    } else if (lastSegment === 'student-bulk-upload') {
      this.base = 'student-bulk-upload';
      this.page = 'student-bulk-upload';
    } else if (lastSegment === 'InactiveS') {
      this.base = 'InactiveS';
      this.page = 'InactiveS';
    } else if (lastSegment === 'DeleteS') {
      this.base = 'DeleteS';
      this.page = 'DeleteS';
    } else if (lastSegment === 'teachers-view') {
      this.base = 'teachers-view';
      this.page = 'teachers-view';
    } else if (lastSegment === 'add-teacher') {
      this.base = 'add-teacher';
      this.page = 'add-teacher';
    } else if (lastSegment === 'digital-report-card') {
      this.base = 'digital-report-card';
      this.page = 'digital-report-card';
    } else if (lastSegment === 'digital-report-card-bulk-upload') {
      this.base = 'digital-report-card-bulk-upload';
      this.page = 'digital-report-card-bulk-upload';
    } else if (lastSegment === 'selectdashboard') {
      this.base = 'selectdashboard';
      this.page = 'selectdashboard';
    } else if (lastSegment === 'term-summary') {
      this.base = 'term-summary';
      this.page = 'term-summary';
    } else if (lastSegment === 'add-subject') {
      this.base = 'add-subject';
      this.page = 'add-subject';
    } else {
      // Handle unknown last segment
      this.base = '';
      this.page = '';
    }
  }






  getGclStatus() {
    this.adminLayoutService.getGclStatus().subscribe(
      (response) => {
        this.localStorage.store("gclStatus", response);
        this.get_User();
        console.log(response);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  //enable api for dataAnalytics Tab
  getDAStatus() {
    this.adminLayoutService.getDAStatus().subscribe(
      (response) => {
        this.localStorage.store("daStatus", response);
        this.get_User();
        console.log(response);
      },
      (error) => {}
    );
  }

  private getPrivateSB(pagenum) {
    this.spinnershow = true;
    var standard = this.localStorage.retrieve("standard");
    var section = this.localStorage.retrieve("section");
    this.adminLayoutService
      .GetSoundingBoardPrivateMessage(
        pagenum,
        this.searchString,
        standard,
        section
      )
      .subscribe(
        (response) => {
          this.data = [];
          this.data = response["items"];
          this.count = response["unreadcount"];
          console.log(this.count);
        },
        (error) => {}
      );
  }
  onClickedOutside(e: Event) {
    if (
      this.windowWidth < 768 &&
      this.toggleOn &&
      this.verticalNavType !== "offcanvas"
    ) {
      this.toggleOn = true;
      this.verticalNavType = "offcanvas";
    }
  }
  public logout() {
    // var myItem = this.localStorage.retrieve('schoollogo');
    this.adminLayoutService.Logout().subscribe((res) => {
      this.msgService.add({
        severity: "success",
        summary: "Talkative Parents",
        detail: "Logged out Successfully",
      });
      console.log(res);
    });
    this.localStorage.clear();
    localStorage.clear();
    // this.localStorage.store('schoollogo', myItem);
    this.router.navigate(["authentication/login"]);
  }
  onResize(event) {
    this.innerHeight = event.target.innerHeight + "px";
    /* menu responsive */
    this.windowWidth = event.target.innerWidth;
    let reSizeFlag = true;
    if (
      this.deviceType === "tablet" &&
      this.windowWidth >= 768 &&
      this.windowWidth <= 1024
    ) {
      reSizeFlag = false;
    } else if (this.deviceType === "mobile" && this.windowWidth < 768) {
      reSizeFlag = false;
    }

    if (reSizeFlag) {
      this.setMenuAttributs(this.windowWidth);
    }
  }

  setMenuAttributs(windowWidth) {
    if (windowWidth >= 768 && windowWidth <= 1024) {
      this.deviceType = "tablet";
      this.verticalNavType = "collapsed";
      this.verticalEffect = "push";
    } else if (windowWidth < 768) {
      this.deviceType = "mobile";
      this.verticalNavType = "offcanvas";
      this.verticalEffect = "overlay";
    } else {
      this.deviceType = "desktop";
      this.verticalNavType = "expanded";
      this.verticalEffect = "shrink";
    }
  }

  toggleOpened() {
    if (this.windowWidth < 768) {
      this.toggleOn =
        this.verticalNavType === "offcanvas" ? true : this.toggleOn;
      this.verticalNavType =
        this.verticalNavType === "expanded" ? "offcanvas" : "expanded";
    } else {
      this.verticalNavType =
        this.verticalNavType === "expanded" ? "collapsed" : "expanded";
    }
  }

  toggleOpenedSidebar() {
    this.isCollapsedSideBar =
      this.isCollapsedSideBar === "yes-block" ? "no-block" : "yes-block";
  }

  onMobileMenu() {
    this.isCollapsedMobile =
      this.isCollapsedMobile === "yes-block" ? "no-block" : "yes-block";
  }

  public get_User() {
    var userId = this.localStorage.retrieve("Id");
    // this.menuData = this.menuItems.getAll();
    // this.menuData = this.menuItems.getUser();
    this.adminLayoutService.permission(userId).subscribe((items) => {
      console.log("these are items ", items);
      this.menuData[0].main = items["selectedPermission"];
      console.log("these are items in admin", items["selectedPermission"]);

      items["selectedPermission"].map((element) => {
        // console.log(element,'ele')

        if (element.children) {
          var elewithchild = element;
          if (elewithchild.id == 5) {
            var groups = {
              name: "Groups",
              state: "Groups",
            };
            element.children.splice(2, 1, groups);
          }

          /*if (elewithchild.id == 10) {
            var Teacher_Details = {
              name: "Teacher Details",
              state: "Teacher_Details",
            };

            var View = {
              name: "View",
              state: "View",
            };

            var Registration = {
              name: "Registration",
              state: "Registration",
            };

            var Subject_Assign = {
              name: "Subject Assign",
              state: "Subject_Assign",
            };

            if (this.localStorage.retrieve("isHigherEdLogin") == true) {
            } else {
              element.children.push(Teacher_Details);
              element.children.push(View);
              element.children.push(Registration);
              element.children.push(Subject_Assign);
            }
          }*/

          if (elewithchild.id == 11) {
            var st = {
              name: "Student Details",
              state: "st",
            };

            var View = {
              name: "View",
              state: "View",
            };

            var viewH = {
              name: "View HigherEnd",
              state: "StudentveiwH",
            };

            var reg = {
              name: "Student Registration",
              state: "studentreg",
            };

            var studentPro = {
              name: "Promotion",
              state: "PromotionsS",
            };

            var ViewProReg = {
              name: "Registration",
              state: "ViewRegistration",
            };

            if (this.localStorage.retrieve("isHigherEdLogin") == true) {
              element.children[0].name = "View HigherEd";
              element.children[0].state = "StudentveiwH";
              element.children.push(reg);
            } else {
              element.children[0].name = "View";
              element.children[0].state = "View";
              element.children.push(studentPro);
              element.children.push(ViewProReg);
              element.children.push({name: "Student Bulk Upload", state: "student-bulk-upload"});
            }
          }
        }
      });
      console.log(this.localStorage.retrieve("gclStatus"));
      if (
        this.localStorage.retrieve("gclStatus") &&
        this.localStorage.retrieve("gclStatus").Value === "Enabled"
      ) {
        ///////////////////////////////////////////////////
        if (this.localStorage.retrieve("isHigherEdLogin") == true) {
        } else {
          this.menuData[0].main.push(this.teacherdetailsmenu);
        }
        ///////////////////////////////////////////////////
        this.menuData[0].main.push(this.GCLMenu);

        //this.menuData[0].main.push(this.BatchMenu);
      }
      if (
        this.localStorage.retrieve("daStatus") &&
        this.localStorage.retrieve("daStatus").Value === "Enabled"
      ) {
        if (this.localStorage.retrieve("isHigherEdLogin") == true) {
          this.AdminData.children[0].name = "Digital Report HigherEd";
          this.AdminData.children[0].state = "digital-report-card2";
        } else {
          if (this.AdminData.children[1].name != "DRC Bulk Upload")
            this.AdminData.children.splice(1, 0, {
              name: "DRC Bulk Upload",
              state: "digital-report-card-bulk-upload",
            });
        }
        this.menuData[0].main.push(this.AdminData);
      }

      console.log("main menu", this.menuData[0].main);


      const newChildOne = {
        name: 'Bulk-Inactive',
        state: 'InactiveS'
      };

      const studentDetailsIndexOne = this.menuData[0].main.findIndex(item => item.name === 'Student Details');

      if (studentDetailsIndexOne !== -1) {
        this.menuData[0].main[studentDetailsIndexOne].children.push(newChildOne);
      }


      const newChildTwo = {
        name: 'Bulk-Deletion',
        state: 'DeleteS'
      };

      const studentDetailsIndexTwo = this.menuData[0].main.findIndex(item => item.name === 'Student Details');

      if (studentDetailsIndexOne !== -1) {
        this.menuData[0].main[studentDetailsIndexTwo].children.push(newChildTwo);
      }


      const newChildThree = {
        name: 'Delete Parent',
        state: 'DeleteParent'
      };

      const studentDetailsIndexThree = this.menuData[0].main.findIndex(item => item.name === 'Student Details');

      if (studentDetailsIndexThree !== -1) {
        this.menuData[0].main[studentDetailsIndexThree].children.push(newChildThree);
      }



      // Find the Data Analytics item
      let dataAnalyticsItem = this.menuData[0].main.find(item => item.name === "Data Analytics");

      // Check if the Data Analytics item exists, has a children array, and doesn't already contain the Term Summary
      if (dataAnalyticsItem && Array.isArray(dataAnalyticsItem.children) &&
        !dataAnalyticsItem.children.some(child => child.name === 'Term Summary')) {

        dataAnalyticsItem.children.push({
          name: 'Term Summary',
          state: 'term-summary' // Replace with the correct state value
        });
      }


      if (dataAnalyticsItem && Array.isArray(dataAnalyticsItem.children) &&
        !dataAnalyticsItem.children.some(child => child.name === 'Class Summary')) {

        dataAnalyticsItem.children.push({
          name: 'Class Summary',
          state: 'class-summary' // Replace with the correct state value
        });
      }


      // Check if the Data Analytics item exists, has a children array, and doesn't already contain the Term Summary
      if (dataAnalyticsItem && Array.isArray(dataAnalyticsItem.children) &&
        !dataAnalyticsItem.children.some(child => child.name === 'DRC Comment Upload')) {

        dataAnalyticsItem.children.push({
          name: 'DRC Comment Upload',
          state: 'digital-report-comment-bulk-upload' // Replace with the correct state value
        });
      }




      const VirtualClassroomIndex = this.menuData[0].main.findIndex(item => item.name === 'Virtual Classroom');

      // Check if the item exists
      if (VirtualClassroomIndex !== -1) {
        // Remove the 'Data Analytics' item from the array
        this.menuData[0].main.splice(VirtualClassroomIndex, 1);
      }

      // const dataAnalyticsIndex = this.menuData[0].main.findIndex(item => item.name === 'Data Analytics');
      //
      // // Check if the item exists
      // if (dataAnalyticsIndex !== -1) {
      //   // Remove the 'Data Analytics' item from the array
      //   this.menuData[0].main.splice(dataAnalyticsIndex, 1);
      // }


      console.log("Updated main menu", this.menuData[0].main);

      if(this.localStorage.retrieve("id") === 306){
        this.menuData[0].main.push({
          children: [],
          icon: "fa fa-gear",
          id: 9,
          name: "General Settings",
          selected: true,
          state: "settings",
          type: "link",
        });
      }



      console.log("Updated main menu after adding General Settings", this.menuData[0].main);

      this.adminLayoutService.getGclStatus().subscribe(
        (response: any) => {
          console.log(response.Value); // Debugging API response
          const status = response.Value;

          if (status === 'Disabled') {
            console.log('enable');

            if (this.menuData[0].main) { // Ensure menuData exists
              this.menuData[0].main = this.menuData[0].main.filter(
                (item: any) => item.state !== 'dataAnalytics'
              );

              console.log("Updated menu after removing Data Analytics:", this.menuData[0].main);
            } else {
              console.log("menuData[0].main is undefined or not initialized.");
            }
          } else {
            console.log('disable');
          }
        },
        (error) => {
          console.log(error);
        }
      );
      if (this.isQuantaEnabled === 0) {
        this.menuData[0].main.pop();
      }
    });
  }


  changeImage() {
    this.display = true;
  }

  triggerFileInput() {
    if (this.fileInput) {
      this.fileInput.nativeElement.click();
    } else {
      console.error('File input element not found');
    }
  }

  changeListener(event: any): void {
    this.readThis(event.target);
  }

  readThis(inputValue: any): void {
    const file: File = inputValue.files[0];
    if (!file) return;

    const myReader = new FileReader();

    myReader.onloadend = () => {
      this.attachmentModel = {
        filename: file.name,
        filesize: file.size,
        filetype: file.type,
        isProfile: false,
        isSchool: true,
        profileId: this.localStorage.retrieve("SchoolId").toString(),
        base64: myReader.result.toString().split(",")[1] || "",
      };

      // Show preview of selected image
      this.schoolLogo = myReader.result as string;

      // ✅ Call saveLogo() API after setting attachmentModel
      this.saveLogo();
    };

    myReader.readAsDataURL(file);
  }


  public saveLogo() {
    if (!this.attachmentModel.base64) {
      this.msgService.add({
        severity: "warning",
        summary: "Talkative Parents",
        detail: "Please choose a Logo",
      });
      return;
    }
    console.log(this.attachmentModel);


    this.noticeboardService.postFile(this.attachmentModel).subscribe(
      (response) => {
        this.display = false;
        const attachment = Object.values(response).toString();
        this.schoolLogo = attachment; // Update the displayed image
        this.localStorage.store("Logo", attachment);
        this.msgService.add({
          severity: "success",
          summary: "Talkative Parents",
          detail: "School Logo Updated",
        });
      },
      (error) => {
        this.display = false;
        this.msgService.add({
          severity: "error",
          summary: "Talkative Parents",
          detail: error.Message,
        });
      }
    );
  }

  ngOnDestroy() {
    this.unsubscribe.unsubscribe();
  }

  isActive(url: string[]): boolean {
    const isActive = this.router.isActive(this.router.createUrlTree(url), true);
    console.log(`Checking if ${url} is active: ${isActive}`);
    return isActive;
  }


}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/layouts/admin/admin-layout.component.ts